import React, {Suspense, Fragment, useState, useEffect} from 'react';
import DatePicker from "react-datepicker";

class CratioDateField extends React.Component{
    constructor(props) {
        super(props);
        let {data, fieldDetail} = this.props;
        let fieldName = fieldDetail[2];
        let fieldLabel = fieldDetail[3];
        let fieldType = fieldDetail[4];
        let isMandatory = parseInt(fieldDetail[16]);
        let defaultValue = fieldDetail[19];
        let defaultDate = data[fieldLabel];
        if(defaultDate === undefined) {
            defaultDate = "";
        } else if(defaultDate === "current"){
            defaultDate = new Date();
        } else {
            if(defaultDate !== "0000-00-00" && defaultDate !== null && defaultDate !== "") {
                defaultDate = new Date(defaultDate);
            } else {
                defaultDate = "";
            }
        }
        this.state = {
            selectedDate : defaultDate,
        }
    }

    handleDatePickerChange = (date, fieldType, fieldLabel) => {
        this.setState({
            selectedDate : date
        })
        this.props.handleDatePickerChange(date, fieldType, fieldLabel);
    }

    render (){
        let {data, fieldDetail,field, errors} = this.props;
        let fieldName = fieldDetail[2];
        let fieldLabel = fieldDetail[3];
        let fieldType = fieldDetail[4];
        let isMandatory = parseInt(fieldDetail[16]);
        let defaultValue = fieldDetail[19];
        if(fieldType === "date"){
            return (
                <DatePicker
                    {...field}
                    id={fieldName + "_fieldid"} name={fieldName + "_fieldinput"}
                    popperPlacement="top"
                    onChange={(e) => {
                        this.handleDatePickerChange(e, fieldType, fieldLabel);
                    }}
                    selected={this.state.selectedDate}
                    className={`form-control ${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`}

                />
            )
        } else if(fieldType === "Date_Time") {
            return (
                <DatePicker
                    {...field}
                    id={fieldName + "_fieldid"} name={fieldName + "_fieldinput"}
                    popperPlacement="top"
                    onChange={(e) => {
                        this.handleDatePickerChange(e, fieldType, fieldLabel);
                    }}
                    selected={this.state.selectedDate}
                    className={`form-control ${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`}
                    showTimeSelect={true}
                    timeFormat="HH:mm"
                    timeIntervals={30}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    timeCaption="Time"
                />
            )
        }
    }
}

export default CratioDateField;
